export const loginRoutes = {
  root: () =>
    '/authentication',
  login: () =>
    `${loginRoutes.root()}/login`,
  otp: () =>
    `${loginRoutes.root()}/otp`,
  updatePassword: () =>
    `${loginRoutes.root()}/update-password`,
};
